import React from "react";

function Logo() {
  return (
    <div className="logo">
      <div className="logo-image"></div>
    </div>
  );
}

export default Logo;
